// types
import { ContactsActionTypes, ContactsState } from './types';

export const INIT_STATE: ContactsState = {
    contacts: [],
    hasMoreContacts: false,
    error: false,
    search: '',
    currentPage: 1
};

const Contacts = (state = INIT_STATE, action: any) => {
    switch (action.type) {
        case ContactsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case ContactsActionTypes.GET_CONTACTS:
                    return {
                        ...state,
                        contacts:
                            action.payload.data.meta.currentPage ===
                                action.payload.data.meta.firstPage ||
                            action.payload.data.meta.total === 0
                                ? action.payload.data.data
                                : [
                                      ...new Set([
                                          ...state.contacts,
                                          ...action.payload.data.data
                                      ])
                                  ],
                        hasMoreContacts:
                            action.payload.data.meta.currentPage <
                            action.payload.data.meta.lastPage,
                        isContactsFetched: true,
                        getContactsLoading: false
                    };
                case ContactsActionTypes.CREATE_CONTACT:
                    return {
                        ...state,
                        contacts: [...state.contacts, action.payload.data.data]
                        /* isContactInvited: true */
                    };
                case ContactsActionTypes.EDIT_CONTACT:
                    return {
                        ...state,
                        contacts: [
                            ...state.contacts.map((contact) => {
                                if (
                                    contact.personId ===
                                    action.payload.data.personId
                                ) {
                                    return {
                                        ...contact,
                                        ...action.payload.data.data
                                    };
                                }
                                return contact;
                            })
                        ]
                    };
                case ContactsActionTypes.DELETE_CONTACT:
                    return {
                        ...state,
                        contacts: [
                            ...state.contacts.filter(
                                (contact) =>
                                    contact.personId !== action.payload.data
                            )
                        ]
                    };
                default:
                    return { ...state };
            }

        case ContactsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case ContactsActionTypes.GET_CONTACTS:
                    return {
                        ...state,
                        isContactsFetched: false,
                        getContactsLoading: false,
                        error: true
                    };
                case ContactsActionTypes.CREATE_CONTACT:
                    return {
                        ...state
                    };
                case ContactsActionTypes.EDIT_CONTACT:
                    return {
                        ...state
                    };
                case ContactsActionTypes.DELETE_CONTACT:
                    return {
                        ...state
                    };
                default:
                    return { ...state };
            }

        case ContactsActionTypes.GET_CONTACTS: {
            return {
                ...state,
                getContactsLoading: true,
                isContactsFetched: false
            };
        }

        case ContactsActionTypes.UPDATE_SEARCH: {
            return {
                ...state,
                search: action.payload,
                currentPage: 1
            };
        }

        case ContactsActionTypes.UPDATE_CURRENT_PAGE: {
            return {
                ...state,
                currentPage: action.payload
            };
        }

        case ContactsActionTypes.CREATE_CONTACT:
            return {
                ...state
                /* isContactInvited: false */
            };

        case ContactsActionTypes.RESET_CONTACTS:
            const flag = action.payload.flag;
            const value = action.payload.value;
            let flags: any = {};
            flags[flag] = value;
            return {
                ...state,
                ...flags,
                error: false
            };
        default:
            return { ...state };
    }
};

export default Contacts;
